import { Injectable } from '@angular/core';

// services
import { PartnerBrandService, ProductService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {
  product!: any;

  constructor(
    private productService: ProductService,
    private partnerBrandService: PartnerBrandService
  ) { }

  public get(slug: string) {
    let params = 'covers,config';
    return this.productService.detail(slug, params)
      .then((response: any) => {
        this.product = response;
        this.partnerBrandService.setAttribute('product', this.product, 'partner');

        return response;
      })
  }
}
